import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const ListElaborationButton = ()=>{
 const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/list_elaboration')
    }
    
    return (
        <Button onClick={handlePage} style={{textAlign:'start'}}>Lista</Button>
    )
}

export default ListElaborationButton